export const initialProjectAgentsState = {
    agentsByIdByProjectId: {},
    agentIdsByProjectId: {},
};
